<app-accounting-template
        [title]="title"
        [apiUrl]="apiUrl"
        [tableInfo]="info"
        [type]="'EXPORTED_BY_ACCOUNTANT'"
        [rowActionsSettings]="AccountingRowActionsSettings"
        [topActionsSettings]="topActionsSettings"
        [filtersSettings]="filtersSettings"
></app-accounting-template>
